import { render } from "./AdminProductsView.vue?vue&type=template&id=b6da99f8&scoped=true&ts=true"
import script from "./AdminProductsView.vue?vue&type=script&lang=ts"
export * from "./AdminProductsView.vue?vue&type=script&lang=ts"

import "@/assets/admin-crud.css?vue&type=style&index=0&id=b6da99f8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6da99f8"]])

export default __exports__